import { FC } from 'react'

import { useLocale } from 'languages/use-locale'
import {
  FacebookIcon,
  YoutubeIcon,
  VKIcon,
  TwitterIcon,
  TelegramIcon,
  InstagramIcon,
  OKIcon,
} from '../../icons/SocialIcons'
import { OpenUrlIcon } from '../../icons/OpenUrlIcon'
import { InfoPageWrapper, useInfoPage } from './info-page-wrapper'

const Platforms: FC = () => {
  const { texts } = useLocale()
  const programInfo = useInfoPage('platforms')

  return (
    <InfoPageWrapper id="platforms">
      <div className="platforms">
        <ul>
          <li>
            <a href="https://www.currenttime.tv/live">
              <OpenUrlIcon />
              <span
                dangerouslySetInnerHTML={{
                  __html: programInfo?.description[0] ?? '',
                }}
              ></span>
            </a>
          </li>
          <li>
            <a href="https://www.currenttime.tv/semsorok">
              <OpenUrlIcon />
              <span
                dangerouslySetInnerHTML={{
                  __html: programInfo?.description[1] ?? '',
                }}
              ></span>
            </a>
          </li>
          <li>
            <a href="https://www.currenttime.tv/app">
              <OpenUrlIcon />
              <span
                dangerouslySetInnerHTML={{
                  __html: programInfo?.description[2] ?? '',
                }}
              ></span>
            </a>
          </li>
        </ul>
        <h3
          dangerouslySetInnerHTML={{
            __html: programInfo?.description[3] ?? '',
          }}
        ></h3>
        <ul className="social_media">
          <li>
            <a
              href={'https://www.' + texts.socialMedia.facebook}
              target="_blank"
            >
              <FacebookIcon />
              <span>{texts.socialMedia.facebook}</span>
            </a>
          </li>
          <li>
            <a
              href={'https://www.' + texts.socialMedia.facebook}
              target="_blank"
            >
              <YoutubeIcon />
              <span>{texts.socialMedia.youtube}</span>
            </a>
          </li>
          <li>
            <a
              href={'https://www.' + texts.socialMedia.facebook}
              target="_blank"
            >
              <VKIcon />
              <span>{texts.socialMedia.vk}</span>
            </a>
          </li>
          <li>
            <a
              href={'https://www.' + texts.socialMedia.facebook}
              target="_blank"
            >
              <TwitterIcon />
              <span>{texts.socialMedia.twitter}</span>
            </a>
          </li>
          <li>
            <a
              href={'https://www.' + texts.socialMedia.facebook}
              target="_blank"
            >
              <TelegramIcon />
              <span>{texts.socialMedia.telegram}</span>
            </a>
          </li>
          <li>
            <a
              href={'https://www.' + texts.socialMedia.facebook}
              target="_blank"
            >
              <InstagramIcon />
              <span>{texts.socialMedia.instagram}</span>
            </a>
          </li>
          <li>
            <a
              href={'https://www.' + texts.socialMedia.facebook}
              target="_blank"
            >
              <OKIcon />
              <span>{texts.socialMedia.ok}</span>
            </a>
          </li>
        </ul>
      </div>
    </InfoPageWrapper>
  )
}

export default Platforms
